module.exports = __webpack_public_path__ + "assets/login-logo7082d003.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/login/images/login-logo.png
// module id = 744
// module chunks = 23